export default "__VITE_ASSET__CzYu6rfJ__"